import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagVN = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m25 13.044 2.699 8.303h8.73l-7.063 5.132 2.698 8.304L25 29.65l-7.063 5.132 2.698-8.304-7.063-5.132h8.73L25 13.044Z"
}));
FlagVN.displayName = 'FlagVN';
export default withFlagWrapper(FlagVN);
//# sourceMappingURL=index.js.map